import src from "IMAGE";
export default { src, width: 400, height: 120, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQElEQVR42h3JsQkAMAgEwOw/SSZJExsRBEEFGyew/0CKq26dc3DvhYjAzMDMn6qiqrD23iAidDfcHRGBzPw5M3gYQTgFkaDnOwAAAABJRU5ErkJggg=="};
